.wrapper {
  display: inline-flex;
  flex-shrink: 0;
  position: relative;
  border-radius: var(--radius-sm);
  overflow: hidden;
  box-shadow:
    0 0 0 1px var(--color-border),
    inset 0 1px 0 rgba(255,255,255,0.05),
    var(--shadow-sm);
  background: var(--color-bg-input);
}

.image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  image-rendering: pixelated;
  image-rendering: crisp-edges;
  transition: transform var(--transition-base);
}

.wrapper:hover .image {
  transform: scale(1.05);
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(0,0,0,0.15) 100%);
  pointer-events: none;
}

/* Sizes */
.xs { width: 20px; height: 20px; }
.sm { width: 32px; height: 32px; }
.md { width: 48px; height: 48px; }
.lg { width: 64px; height: 64px; }
.xl { width: 96px; height: 96px; }

/* Name display */
.inline {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.linkWrapper {
  text-decoration: none;
  color: inherit;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  transition: opacity var(--transition-fast);
}

.linkWrapper:hover {
  opacity: 0.8;
}

.name {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 13px;
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

/* Size-responsive name */
.xs + .name,
.sm + .name { font-size: 11px; max-width: 100px; }
.md + .name { font-size: 13px; max-width: 140px; }
.lg + .name { font-size: 14px; max-width: 180px; }
.xl + .name { font-size: 16px; max-width: 220px; }